import {
  FullAsinWithAudits,
  RestrictedAsin,
} from "../../server/asin-central/model";

// Checks if all ASINs are unrestricted AND all ASINs have the same programId
export function currentPagePorAsinsBelongToSameProgram(
  asins: Array<FullAsinWithAudits | RestrictedAsin>
): boolean {
  return (
    asins.every((a) => !a.isRestricted) &&
    (asins as Array<FullAsinWithAudits>).every(
      (a) => a.programId === (asins[0] as FullAsinWithAudits).programId
    )
  );
}
